export default "__VITE_ASSET__kYWg2ZUC__"